(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductPanel extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantId = this.form?.querySelector('[name="id"]');
      this.addButton = this.querySelector('[data-add-button]');
      this.addLabelValue = this.querySelector('[data-add-label-value]');
      this.variantPrice = this.querySelector('[data-variant-price]');
      this.addLoader = this.querySelector('[data-add-loader]');
      this.addSuccess = this.querySelector('[data-add-success]');
      this.addStatus = this.querySelector('[data-add-status]');
      this.sizeOption = this.querySelector('[data-size-option]');
      this.variants = JSON.parse(this.querySelector('[data-product-variants]')?.textContent || '[]');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.dialog = this.querySelector('[data-size-guide-dialog]');
      this.gallerySources = [...this.querySelectorAll('[data-gallery-source]')];
      this.galleryCounter = this.querySelector('[data-gallery-counter]');
      this.mobileGallery = this.querySelector('[data-gallery-mobile-track]');
      this.desktopGallery = this.querySelector('[data-gallery-desktop-track]');
      this.gallery = this.querySelector('.product-gallery');
      this.galleryIndex = 0;
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.desktopWheelHandler = this.#handleDesktopWheel.bind(this);
      this.addToCartHandler = this.#handleAddToCart.bind(this);
      this.form?.addEventListener('change', this.#updateVariant.bind(this));
      this.form?.addEventListener('submit', this.addToCartHandler, true);
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.#selectTab(tab)));
      this.tabs.forEach((tab) => tab.addEventListener('keydown', this.#handleTabKeys.bind(this)));
      this.querySelector('[data-size-guide-open]')?.addEventListener('click', this.#openDialog.bind(this));
      this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', this.#handleDialogBackdropClick.bind(this));
      this.dialog?.addEventListener('close', () => this.dialogTrigger?.focus());
      this.mobileGallery?.addEventListener('scroll', this.#updateMobileGalleryIndex.bind(this), { passive: true });
      this.desktopGallery?.addEventListener('scroll', this.#updateDesktopGalleryIndex.bind(this), { passive: true });
      window.addEventListener('wheel', this.desktopWheelHandler, { passive: false });
    }
    disconnectedCallback() {
      window.removeEventListener('wheel', this.desktopWheelHandler);
      this.form?.removeEventListener('submit', this.addToCartHandler, true);
      window.clearTimeout(this.addConfirmationTimeout);
    }
    #selectedOptions() {
      return [...this.form.querySelectorAll('fieldset')].map((field) => field.querySelector('input:checked')?.value);
    }
    #hasSelectedSize() {
      return !this.sizeOption || Boolean(this.sizeOption.querySelector('input:checked'));
    }
    #updateVariant() {
      const selectedOptions = this.#selectedOptions();
      const variant = this.#findVariant(selectedOptions);
      if (!this.#hasSelectedSize() || !variant) {
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-disabled', 'true');
        return;
      }
      this.variantId.value = variant.id;
      this.variantId.dispatchEvent(new Event('change', { bubbles: true }));
      if (this.addButton.dataset.addState) return;
      this.addButton.disabled = !variant.available;
      this.addButton.setAttribute('aria-disabled', String(!variant.available));
      this.addLabelValue.textContent = variant.available
        ? this.addButton.dataset.addLabel
        : this.addButton.dataset.soldOutLabel;
      this.variantPrice.innerHTML = this.#formatMoney(variant.price);
      const mediaIndex = this.gallerySources.findIndex(
        (source) => source.dataset.mediaId === String(variant.featured_media?.id)
      );
      if (mediaIndex >= 0) {
        this.#showGalleryImage(mediaIndex);
        this.#showMobileGalleryImage(mediaIndex);
      }
    }
    #findVariant(selectedOptions = this.#selectedOptions()) {
      if (!selectedOptions.length) {
        return this.variants.find((item) => String(item.id) === this.variantId?.value) || this.variants[0];
      }

      return this.variants.find((item) =>
        item.options.every((option, index) => option === selectedOptions[index])
      );
    }
    async #handleAddToCart(event) {
      if (!this.form || !this.addButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.addButton.disabled || !this.#hasSelectedSize()) {
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-disabled', 'true');
        return;
      }
      this.#setAddState('loading');

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Failed to add item to cart');

        await new Promise((resolve) => window.setTimeout(resolve, 150));
        await window.updateCartDrawer?.();
        this.#showAddConfirmation();
      } catch (error) {
        console.error('Add to cart failed:', error);
        this.#resetAddState();
      }
    }
    #setAddState(state) {
      this.addButton.dataset.addState = state;
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-disabled', 'true');
      this.addButton.setAttribute('aria-busy', String(state === 'loading'));
      this.addLoader.hidden = state !== 'loading';
      this.addSuccess.hidden = state !== 'success';
      this.addStatus.textContent = state === 'success' ? this.addButton.dataset.addedLabel : '';
    }
    #showAddConfirmation() {
      this.#setAddState('success');
      window.clearTimeout(this.addConfirmationTimeout);
      this.addConfirmationTimeout = window.setTimeout(() => this.#resetAddState(), this.#confirmationDuration());
    }
    #resetAddState() {
      window.clearTimeout(this.addConfirmationTimeout);
      delete this.addButton.dataset.addState;
      this.addButton.removeAttribute('aria-busy');
      this.addLoader.hidden = true;
      this.addSuccess.hidden = true;
      this.addStatus.textContent = '';
      this.addButton.disabled = !this.#hasSelectedSize() || !this.#findVariant()?.available;
      this.addButton.setAttribute('aria-disabled', String(this.addButton.disabled));
    }
    #confirmationDuration() {
      const duration = getComputedStyle(this.addButton)
        .getPropertyValue('--product-panel-add-confirmation-duration')
        .trim();
      const match = duration.match(/^(\d*\.?\d+)(ms|s)$/);
      if (!match) return 1000;

      return Number(match[1]) * (match[2] === 's' ? 1000 : 1);
    }
    #formatMoney(cents) {
      const format = this.querySelector('.product-panel')?.dataset.moneyFormat;
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format);

      const amount = Number(cents) / 100;
      const placeholder = /\{\{\s*(amount[\w_]*)\s*\}\}/;
      const match = format?.match(placeholder);
      if (!match) return amount.toFixed(2);

      const formatOptions = {
        amount: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        amount_no_decimals: { maximumFractionDigits: 0 },
        amount_with_comma_separator: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        amount_no_decimals_with_comma_separator: { maximumFractionDigits: 0 },
        amount_with_apostrophe_separator: { maximumFractionDigits: 2, minimumFractionDigits: 2 },
      };
      const separators = {
        amount: [',', '.'],
        amount_no_decimals: [',', '.'],
        amount_with_comma_separator: ['.', ','],
        amount_no_decimals_with_comma_separator: ['.', ','],
        amount_with_apostrophe_separator: ["'", '.'],
      };
      const [thousandsSeparator, decimalSeparator] = separators[match[1]] || separators.amount;
      const formattedAmount = new Intl.NumberFormat('en', {
        ...(formatOptions[match[1]] || formatOptions.amount),
        useGrouping: true,
      })
        .formatToParts(amount)
        .map((part) => {
          if (part.type === 'group') return thousandsSeparator;
          if (part.type === 'decimal') return decimalSeparator;
          return part.value;
        })
        .join('');

      return format.replace(placeholder, formattedAmount);
    }
    #openDialog(event) {
      this.dialogTrigger = event.currentTarget;
      this.dialog?.showModal();
    }
    #handleDialogBackdropClick(event) {
      if (!this.dialog) return;
      const bounds = this.dialog.getBoundingClientRect();
      const clickedOutsideDialog =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;
      if (clickedOutsideDialog) this.dialog.close();
    }
    #handleDesktopWheel(event) {
      if (
        !this.desktopMediaQuery.matches ||
        this.gallerySources.length < 2 ||
        !this.desktopGallery ||
        !this.#galleryIsInView()
      ) return;

      const galleryAtBottom = Math.ceil(this.desktopGallery.scrollTop + this.desktopGallery.clientHeight) >= this.desktopGallery.scrollHeight;
      const galleryAtTop = this.desktopGallery.scrollTop <= 0;
      const canScrollDown = event.deltaY > 0 && !galleryAtBottom;
      const canScrollUp = event.deltaY < 0 && window.scrollY <= 1 && !galleryAtTop;
      if (!canScrollDown && !canScrollUp) return;

      event.preventDefault();
      this.desktopGallery.scrollBy({ top: event.deltaY, behavior: 'auto' });
    }
    #galleryIsInView() {
      if (!this.gallery) return false;
      const bounds = this.gallery.getBoundingClientRect();
      return bounds.bottom > 0 && bounds.top < window.innerHeight;
    }
    #showGalleryImage(index) {
      if (!this.desktopGallery || !this.gallerySources[index]) return;
      this.desktopGallery.scrollTo({ top: this.desktopGallery.clientHeight * index, behavior: 'smooth' });
      this.galleryIndex = index;
      if (this.galleryCounter) this.galleryCounter.textContent = `${index + 1}/${this.gallerySources.length}`;
    }
    #updateDesktopGalleryIndex() {
      if (!this.desktopGallery || !this.gallerySources.length) return;
      const index = Math.round(this.desktopGallery.scrollTop / this.desktopGallery.clientHeight);
      if (index === this.galleryIndex) return;
      this.galleryIndex = index;
      if (this.galleryCounter) this.galleryCounter.textContent = `${index + 1}/${this.gallerySources.length}`;
    }
    #showMobileGalleryImage(index) {
      if (!this.mobileGallery) return;
      this.mobileGallery.scrollTo({ left: this.mobileGallery.clientWidth * index, behavior: 'smooth' });
    }
    #updateMobileGalleryIndex() {
      if (!this.mobileGallery || !this.gallerySources.length) return;
      const index = Math.round(this.mobileGallery.scrollLeft / this.mobileGallery.clientWidth);
      if (index === this.galleryIndex) return;
      this.galleryIndex = index;
      if (this.galleryCounter) this.galleryCounter.textContent = `${index + 1}/${this.gallerySources.length}`;
    }
    #selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        const selected = tab === selectedTab;
        tab.classList.toggle('product-panel__tab--active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.querySelector(`#${tab.getAttribute('aria-controls')}`).hidden = !selected;
      });
    }
    #handleTabKeys(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const index = this.tabs.indexOf(event.currentTarget);
      const nextIndex =
        event.key === 'Home'
          ? 0
          : event.key === 'End'
          ? this.tabs.length - 1
          : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
      this.tabs[nextIndex].focus();
      this.#selectTab(this.tabs[nextIndex]);
    }
  }
  if (!customElements.get('product-panel')) customElements.define('product-panel', ProductPanel);

  } catch(e) { console.error(e); }
})();
})();
